












































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetDetailLeftNavDoneList } from "@/request/edr";
@Component({})
export default class CdrPatientDetailNav extends Vue {
  @Prop()
  private cState: any;
  @Prop()
  private patient: any;
  @Prop()
  private nav: any;
  private cWrap: any = "";
  private zyyx: any[] = [];
  private tongyongIndex: any = "";
  private tongyongs: any = [];
  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }
  @Watch("nav", { deep: true })
  private navChange() {
    this.nav.forEach((item: any, index: any) => {
      if (item["访视名称"] === "通用") {
        this.tongyongIndex = index;
        return;
      }
      let exsit: boolean = false;
      item.templates.forEach((template: any) => {
        if (template["名称"] === this.cState) {
          exsit = true;
        }
      });
      if (exsit) {
        this.cWrap = item["访视名称"];
      }
    });
    // 处理通用访视
    if (this.tongyongIndex || this.tongyongIndex === 0) {
      const item = this.nav[this.tongyongIndex];
      this.tongyongs = item.templates;
    }
    if (
      this.cState === "舌象数据-科研版" ||
      this.cState === "面象数据" ||
      this.cState === "脉象数据"
    ) {
      this.cWrap = "中医影像";
    }
  }
  @Watch("patient", { deep: true, immediate: true })
  private patientChange() {
    if (this.patient.patient_id) {
      this.fetchDoneList();
    }
  }
  /**
   * @description 检测当前用户
   */
  private fetchDoneList() {
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
      },
    };
    GetDetailLeftNavDoneList(this, params).then((data: any) => {
      // console.log(data);
      this.zyyx = data;
    });
  }
  /**
   * @description 跳转
   */
  private goTo(part) {
    if (this.ifCompose) {
      this.$emit("needSave", part);
      // this.$message.warning("数据尚未保存，请先保存");
    } else {
      this.$emit("jump", part);
    }
  }

  /**
   * @description 切换开关
   */
  private triggerWrap(name) {
    this.cWrap = name;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    // console.log(this.nav);
  }
}
